
import React, {FC} from 'react';
import {Location} from 'components/TimePicker/types';
import {createBookingLink} from 'utils/booking';

import * as styles from './styles.module.scss';

const DefaultLocationPhoto = 'https://static.bodyspec.com/at/60/59/60597a46a154538d';

type PlaceProps = {
	location: Location
	distance: number
}

const Place: FC<PlaceProps> = ({location}) => {
	const photo = location.photos.urls[0] || DefaultLocationPhoto;
	const url = createBookingLink({
		slug: location.details.slug,
		date: location.datesLeft[0].date,
	});

	return (
		<div className={styles.place}>
			<a href={url}>
				<div className={styles.image}>
					<img src={photo} alt={location.details.name} />
				</div>
			</a>
			<a className={styles.title} href={url}>
				{location.details.name}
			</a>
			<div className={styles.address}>
				{location.details.address.addr1}{', '}
				{location.details.address.addr2}
			</div>
		</div>
	);
};

export default Place;
